import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiCountrySelectModule } from '../lib/shared-ui-country-select.module'
import { CountrySelectDocsComponent } from './country-select-docs/country-select-docs.component'
import { CountrySelectExampleComponent } from './country-select-docs/country-select-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiCountrySelectModule
  ],
  declarations: [
    CountrySelectDocsComponent,
    CountrySelectExampleComponent
  ],
  exports: [
    CountrySelectDocsComponent
  ]
})
export class SharedUiCountrySelectDocsModule {}
